<svg
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  focusable="false"
  aria-hidden="true"
>
  <path
    d="M26.6432 16.848C27.2698 16.4563 27.2698 15.5437 26.6432 15.152L8.19662 3.62291C7.53058 3.20663 6.66663 3.68548 6.66663 4.47091V27.5291C6.66663 28.3145 7.53058 28.7934 8.19662 28.3771L26.6432 16.848Z"
    [attr.fill]="fillColor"
  />
</svg>
